import React, { useMemo, useState } from 'react';
import DraggableWindow from './DraggableWindow';
import { caixasService } from '../../services/api';

const WindowConfereCaixa = ({ onClose, onMinimize, isMinimized, zIndex, onFocus, userData }) => {
  const defaultFilial = userData?.loja_id ?? userData?.cdfil ?? userData?.CDFIL ?? '';
  const defaultMatricula = userData?.matricula ?? userData?.cdfun ?? userData?.CDFUN ?? '';

  const [caixa, setCaixa] = useState('');
  const [filial, setFilial] = useState(String(defaultFilial || ''));
  const [matricula, setMatricula] = useState(String(defaultMatricula || ''));
  const [loading, setLoading] = useState(false);
  const [erro, setErro] = useState('');
  const [okMsg, setOkMsg] = useState('');
  const [raw, setRaw] = useState(null);

  const canSubmit = useMemo(() => {
    return String(caixa).trim() && String(filial).trim() && String(matricula).trim() && !loading;
  }, [caixa, filial, matricula, loading]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErro('');
    setOkMsg('');
    setRaw(null);

    const caixaStr = String(caixa || '').trim();
    if (!caixaStr) {
      setErro('Informe o número da caixa.');
      return;
    }

    setLoading(true);
    try {
      const resp = await caixasService.confereCaixa({
        caixa: caixaStr,
        filial: String(filial || '').trim(),
        matricula: String(matricula || '').trim()
      });
      setOkMsg(`Caixa ${caixaStr} conferida com sucesso.`);
      setRaw(resp?.data ?? resp);
      setCaixa('');
    } catch (err) {
      console.error('Erro ao conferir caixa:', err);
      setErro(err?.message || 'Erro ao conferir caixa.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <DraggableWindow
      title="Conferir Caixa"
      icon="fa-boxes-stacked"
      onClose={onClose}
      onMinimize={onMinimize}
      isMinimized={isMinimized}
      zIndex={zIndex}
      onFocus={onFocus}
      initialWidth={760}
      initialTop={100}
      initialLeft={430}
    >
      <form onSubmit={handleSubmit} className="consulta-form">
        <div className="consulta-form-group">
          <label>Número da Caixa</label>
          <input
            type="text"
            value={caixa}
            onChange={(e) => setCaixa(e.target.value)}
            placeholder="Ex: 1234"
            autoComplete="off"
          />
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
          <div className="consulta-form-group" style={{ marginBottom: 0 }}>
            <label>Filial</label>
            <input
              type="text"
              value={filial}
              onChange={(e) => setFilial(e.target.value)}
              placeholder="Ex: 22"
              autoComplete="off"
            />
          </div>
          <div className="consulta-form-group" style={{ marginBottom: 0 }}>
            <label>Matrícula</label>
            <input
              type="text"
              value={matricula}
              onChange={(e) => setMatricula(e.target.value)}
              placeholder="Ex: 3794"
              autoComplete="off"
            />
          </div>
        </div>

        <button type="submit" className="consulta-btn-submit" disabled={!canSubmit} style={{ marginTop: 12 }}>
          <i className={`fas ${loading ? 'fa-spinner fa-spin' : 'fa-check'}`}></i>
          {loading ? 'Enviando...' : 'Conferir Caixa'}
        </button>
      </form>

      {erro && (
        <div className="consulta-error" style={{ marginTop: 12 }}>
          <strong><i className="fas fa-exclamation-triangle"></i> {erro}</strong>
        </div>
      )}

      {okMsg && (
        <div style={{ marginTop: 12, background: '#ecfdf5', border: '1px solid #a7f3d0', color: '#065f46', padding: 12, borderRadius: 10, fontWeight: 700 }}>
          <i className="fas fa-check-circle"></i> {okMsg}
        </div>
      )}

      {raw && (
        <details style={{ marginTop: 12 }}>
          <summary style={{ cursor: 'pointer', fontWeight: 700, color: '#374151' }}>Resposta bruta</summary>
          <pre style={{ marginTop: 8, background: '#111827', color: '#f8fafc', padding: 12, borderRadius: 10, fontSize: 12, overflow: 'auto' }}>
            {JSON.stringify(raw, null, 2)}
          </pre>
        </details>
      )}
    </DraggableWindow>
  );
};

export default WindowConfereCaixa;
